import { GameConstants } from "../../../GameConstants";
import { StageContainer } from "../StageContainer";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../AudioManager";

export class Car extends Phaser.Sprite {

    public static SPEED = 4;

    public changingLane: boolean;
    public lane: number;
    public fastCar: boolean;
    public newLane: number;
    public carOnCone: boolean;

    private shouldChangeLane: boolean;
    private speedY: number;
    private speedX: number;
    private renderTexture: Phaser.RenderTexture;
    private bloodImage: Phaser.Image;
    private carType: string;
    private canPlaySound: boolean;
    private carBraked: boolean;
    
    constructor(game: Phaser.Game, carType: string, lane: number) {

        super(game, 0, 0, "texture_atlas_1");

        this.lane = lane;
        this.newLane = -1;
        this.shouldChangeLane = false;
        this.speedX = 0;
        this.fastCar = false;
        this.name = GameConstants.CAR;
        this.carType = carType;
        this.canPlaySound = true;
        this.carBraked = false;
        this.newLane = this.lane;

        this.scale.set(.9);

        this.setFrameName();

        this.game.physics.enable(this, Phaser.Physics.ARCADE);

        // darle un offset de 10px al body del coche para dar sensacion de profundidad
        const body = <Phaser.Physics.Arcade.Body> this.body;
        body.height -= 10;   
        body.offset.y = 10;
        
        this.x = StageContainer.LANES_PX[lane];
        this.anchor.set(.5, 1);

        this.renderTexture = new Phaser.RenderTexture(this.game, 42, 115);
        this.bloodImage = new Phaser.Image(this.game, -this.width / 2, -this.height, this.renderTexture);

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            this.bloodImage.visible = showBlood;
        }
        
        this.addChild(this.bloodImage);
        
        this.setSpeed();
    }

    public update(): void {

        super.update();

        if (GameVars.paused || this.carOnCone) {
            return;
        }

        this.soundCar();

        let speedFactor = GameVars.freezeAction ? .1 : 1;

        this.y += this.speedY * speedFactor;
        
        if (this.shouldChangeLane && this.canChangeLane()) {
            this.changeLane();
        }

        if (this.changingLane) {

            this.x += this.speedX * speedFactor;

            if (Phaser.Math.fuzzyEqual(this.x, StageContainer.LANES_PX[this.newLane], 1.5)) {
                this.changingLane = false;
                this.x = StageContainer.LANES_PX[this.newLane];
            }
        }

        if (!this.carBraked && this.speedY > .5) {
            this.adjustSpeed();
        }

        let outOfStage = false;

        if (this.lane < 3) {
            if (this.y > 600) {
                outOfStage = true;
            }
        } else {
            if (this.y < -120) {
                outOfStage = true;
            }
        } 

        if (outOfStage) {
            this.respawn();
        }
    }

    public soundCar(): void {

        if (this.canPlaySound) {
            if ((this.y > 0 && this.lane < 3) || (this.y < GameConstants.GAME_HEIGHT && this.lane >= 3)) {
                if (this.fastCar) {
                    AudioManager.playSound("car_pass_fast", false, .1);
                } else {
                    AudioManager.playSound("car_pass_slow", false, .1);
                }
                this.canPlaySound = false;
            }
        }
    }

    public onChickenHit(pedestrian_px: number): void {

        if (GameVars.noBloodMode) {
            return;
        }
        
        let px = pedestrian_px - this.x + this.width / 2;
        let py = this.lane < 3 ? this.height - 5 : 0;

        let n: number;
        let dy: number;
        
        if (this.lane < 3) {
            n = 8;
            dy = -4;
        } else {
            n = 6;
            dy = 4;
        }

        const graphics = new Phaser.Graphics(this.game, 0, 0);
        graphics.beginFill(GameConstants.BLOOD_COLOR);

        for (let i = 0; i < n; i ++) {

            let bloodDrop_x = GameVars.randomDataGenerator.realInRange(-4, 4);
            let bloodDrop_y = i * dy * GameVars.randomDataGenerator.realInRange(1, 1.35); 
            let bloodDropDiameter = GameVars.randomDataGenerator.integerInRange(3, i > n / 2 ? 5 : 9);
            graphics.drawCircle(bloodDrop_x, bloodDrop_y, bloodDropDiameter);
        }
        
        graphics.endFill();

        this.renderTexture.renderXY(graphics, px, py);
    }

    private adjustSpeed(): void {

        const stageContainer = StageContainer.currentInstance;
        const cars = stageContainer.cars;

        let carInTheSameLane: Car = null;

        for (let i = 0; i < cars.length; i ++) {

            const car = cars[i];

            if (this.lane !== car.lane && (this.lane === cars[i].newLane || this.newLane === cars[i].lane)) {

                if (this.lane < 3) {
                    if (car.y > this.y) {
                        carInTheSameLane = car;
                        break;
                    }
                } else {
                    if (car.y < this.y) {
                        carInTheSameLane = car;
                        break;
                    }
                }
            }
        }

        if (carInTheSameLane !== null && Math.abs(this.speedY) > 1.25) {

            this.carBraked = true;
            
            // mirar la distancia entre los 2 coches
            const d = Math.abs(this.y - carInTheSameLane.y);

            if (d < 200 ) {
                
                this.game.add.tween(this)
                    .to({speedY: this.speedY * .5}, 100, Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function(): void {
                        this.game.add.tween(this)
                            .to({speedY: Car.SPEED}, 350, Phaser.Easing.Cubic.Out, true, 250);
                    }, this);
            }
        }
    }

    private canChangeLane(): boolean {

        const stageContainer = StageContainer.currentInstance;
        const cars = stageContainer.cars;

        // solo puede haber un choche cambiando a la vez de carril por sentido
        if (this.lane < 3) {
            for (let i = 0; i < 3; i ++) {
                if (cars[i].changingLane) {
                    return false;
                }
            }
        } else {
            for (let i = 3; i < 6; i ++) {
                if (cars[i].changingLane) {
                    return false;
                }
            }
        }
        
        // una aproximacion bastante gorda, mirar q no tenga ningun coche delante ni por detras en unos 200px
        // al ser generosos con la posibilidad de q el coche adelante esto funciona razonablemente bien
        let ret = false;

        if (this.y > 50 && this.y < GameConstants.GAME_HEIGHT - 100) {
            
            let hasCarClose = false;
            const range = 200;

            if (this.lane < 3) {
                for (let i = 0; i < 3; i ++) {
                    if (i !== this.lane && Phaser.Math.fuzzyEqual(this.y, cars[i].y, range) || cars[i].fastCar) {
                        hasCarClose = true;
                        break;
                    }
                }
            } else {
                for (let i = 3; i < 6; i ++) {
                    if (i !== this.lane && Phaser.Math.fuzzyEqual(this.y, cars[i].y, range) || cars[i].fastCar) {
                        hasCarClose = true;
                        break;
                    }
                }
            }

            ret = !hasCarClose;
        }

        return ret;
    }

    private changeLane(): void {

        this.shouldChangeLane = false;
        this.changingLane = true;

        if (this.lane === 0) {
            this.newLane = 1;
            this.speedX = this.speedY / 3;
        } else if (this.lane === 5) {
            this.newLane = 4;
            this.speedX = this.speedY / 3;
        } else if (this.lane === 2) {
            this.newLane = 1;
            this.speedX = -this.speedY / 3;
        } else if (this.lane === 3) {
            this.newLane = 4;
            this.speedX = -this.speedY / 3;
        } else if (this.lane === 1 || this.lane === 4) {
            
            if (Math.random() > .5) {
                this.newLane = this.lane + 1;
                this.speedX = Math.abs(this.speedY / 3);
            } else {
                this.newLane = this.lane - 1;
                this.speedX = -Math.abs(this.speedY / 3);
            }
        } 
    }

    private respawn(): void {

        this.carType = Phaser.ArrayUtils.getRandomItem(StageContainer.CARS);
        this.setFrameName();

        const body = <Phaser.Physics.Arcade.Body> this.body;
        body.setSize(this.width, this.height);
        body.height -= 10;    // para dar sensacion de profundidad
        body.offset.y = 10;

        this.x = StageContainer.LANES_PX[this.lane];
        // this.scale.x = 1;

        if (this.lane < 3) {
            this.y = GameVars.randomDataGenerator.realInRange(-150, -GameConstants.GAME_HEIGHT);
            this.speedY = Car.SPEED * GameVars.randomDataGenerator.realInRange(1, 1.5);
        } else {
            this.y = GameVars.randomDataGenerator.realInRange(GameConstants.GAME_HEIGHT + 150, 2 * GameConstants.GAME_HEIGHT);
            this.speedY = -Car.SPEED * GameVars.randomDataGenerator.realInRange(1, 1.5);
        }

        // LO REFERENTE A LA RENDER TEXTURE DONDE SE PINTA LA SANGRE
        this.renderTexture.clear();
        this.bloodImage.y = -this.height;

        this.setSpeed();

        if (this.fastCar) {
            this.shouldChangeLane = false;
        } else {
            this.shouldChangeLane = Math.random() < .4;
        }
            
        this.speedX = 0;
        this.changingLane = false;
        this.canPlaySound = true;
        this.newLane = this.lane;
    }

    private setSpeed(): void {

        if (this.lane < 3) {
            this.speedY = Car.SPEED * GameVars.randomDataGenerator.realInRange(.75, 1.5);
        } else {
            this.speedY = -Car.SPEED * GameVars.randomDataGenerator.realInRange(.75, 1.5);
        }

        // coches con alta velocidad
        if (Math.random() < .35) { 
            this.speedY *= 2.25;
            this.fastCar = true;
        } else {
            this.fastCar = false;
        }
    }

    private setFrameName(): void {

        let front = this.lane < 3;

        switch (this.carType) {

            case GameConstants.CAR_TYPE_1:
                this.frameName = front ? "car_1_front.png" : "car_1_back.png";
                break;
            
            case GameConstants.CAR_TYPE_2:
                this.frameName = front ? "car_2_front.png" : "car_2_back.png";
                break;

            case GameConstants.CAR_TYPE_3:
                this.frameName = front ? "car_3_front.png" : "car_3_back.png";
                break;

            case GameConstants.CAR_TYPE_4:
                this.frameName = front ? "car_4_front.png" : "car_4_back.png";
                break;

            case GameConstants.CAR_TYPE_5:
                this.frameName = front ? "car_5_front.png" : "car_5_back.png";
                break;

            case GameConstants.CAR_TYPE_6:
                this.frameName = front ? "car_6_front.png" : "car_6_back.png";
                break;

            case GameConstants.CAR_TYPE_7:
                this.frameName = front ? "car_7_front.png" : "car_7_back.png";
                break;

            case GameConstants.CAR_TYPE_8:
                this.frameName = front ? "car_8_front.png" : "car_8_back.png";
                break;

            case GameConstants.CAR_TYPE_9:
                this.frameName = front ? "car_9_front.png" : "car_9_back.png";
                break;

            case GameConstants.CAR_TYPE_10:
                this.frameName = front ? "car_10_front.png" : "car_10_back.png";
                break;
        
            default:
                break;
        }
    }
}
